export const UNAUTHORIZED_REQUEST = 'auth/UNAUTHORIZED_REQUEST';
export const INSUFFICIENT_PERMISSIONS = 'auth/INSUFFICIENT_PERMISSIONS';
